module.exports = __webpack_public_path__ + "static/2-intro-description-e04a8dcd81d685c727f3bb4842bf079d.png";